import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textXSObj } = typographyStyles;

export const rootCss = {
  display: "inline-flex",
  borderRadius: "12px",
  padding: "2px 8px",
  lineHeight: "1rem",
  color: colors.ui.white[500],
  alignItems: "center",
};

export const iconCss = {
  width: 12,
  height: 12,
  marginRight: 4,
  lineHeight: 0,
  path: {
    stroke: colors.ui.white[500],
    strokeWidth: 4,
  },
};

export const labelTextCss = {
  ...textXSObj,
  textTransform: "capitalize",
};

export const labelColorCss = (status) => {
  switch (status) {
    case "success":
      return {
        backgroundColor: colors.ui.green[500],
      };
    case "danger":
      return {
        backgroundColor: colors.ui.red[500],
      };
    case "primary":
    default:
      return {
        backgroundColor: colors.ui.neutral[700],
      };
  }
};
